import { createFileRoute } from "@tanstack/react-router";
import { RadixDesignSystem } from "@/pages/design-system/RadixDesignSystem";

export const Route = createFileRoute("/demo/design-system/radix/")({
  component: RadixDesignSystem,
});
